const IconAssets = {
  'chat-hide': require('./ic-chat-hide.png'),
  'chat-show': require('./ic-chat-show.png'),
  'add': require('./icon-add.png'),
  'archive': require('./icon-archive.png'),
  'arrow-left': require('./icon-arrow-left.png'),
  'audio-off-filled': require('./icon-audio-off-filled.png'),
  'audio-off': require('./icon-audio-off.png'),
  'audio-on-filled': require('./icon-audio-on-filled.png'),
  'audio-on': require('./icon-audio-on.png'),
  'ban': require('./icon-ban.png'),
  'broadcast': require('./icon-broadcast.png'),
  'camera': require('./icon-camera.png'),
  'channels': require('./icon-channels.png'),
  'chat-filled': require('./icon-chat-filled.png'),
  'chat': require('./icon-chat.png'),
  'checkbox-off': require('./icon-checkbox-off.png'),
  'checkbox-on': require('./icon-checkbox-on.png'),
  'chevron-down': require('./icon-chevron-down.png'),
  'chevron-right': require('./icon-chevron-right.png'),
  'close': require('./icon-close.png'),
  'copy': require('./icon-copy.png'),
  'create': require('./icon-create.png'),
  'delete': require('./icon-delete.png'),
  'document': require('./icon-document.png'),
  'done-all': require('./icon-done-all.png'),
  'done': require('./icon-done.png'),
  'download': require('./icon-download.png'),
  'edit': require('./icon-edit.png'),
  'emoji-more': require('./icon-emoji-more.png'),
  'error': require('./icon-error.png'),
  'file-audio': require('./icon-file-audio.png'),
  'file-document': require('./icon-file-document.png'),
  'freeze': require('./icon-freeze.png'),
  'gif': require('./icon-gif.png'),
  'info': require('./icon-info.png'),
  'leave': require('./icon-leave.png'),
  'mark-as-unread': require('./icon-mark-as-unread.png'),
  'members': require('./icon-members.png'),
  'message': require('./icon-message.png'),
  'moderation': require('./icon-moderation.png'),
  'more': require('./icon-more.png'),
  'mute': require('./icon-mute.png'),
  'notifications-filled': require('./icon-notifications-filled.png'),
  'notifications-off-filled': require('./icon-notifications-off-filled.png'),
  'notifications': require('./icon-notifications.png'),
  'operator': require('./icon-operator.png'),
  'pause': require('./icon-pause.png'),
  'photo': require('./icon-photo.png'),
  'play': require('./icon-play.png'),
  'plus': require('./icon-plus.png'),
  'question': require('./icon-question.png'),
  'radio-off': require('./icon-radio-off.png'),
  'radio-on': require('./icon-radio-on.png'),
  'recording': require('./icon-recording.png'),
  'refresh': require('./icon-refresh.png'),
  'remove': require('./icon-remove.png'),
  'reply-filled': require('./icon-reply-filled.png'),
  'reply': require('./icon-reply.png'),
  'search': require('./icon-search.png'),
  'send': require('./icon-send.png'),
  'settings-filled': require('./icon-settings-filled.png'),
  'spinner': require('./icon-spinner.png'),
  'stop': require('./icon-stop.png'),
  'streaming': require('./icon-streaming.png'),
  'supergroup': require('./icon-supergroup.png'),
  'theme': require('./icon-theme.png'),
  'thread': require('./icon-thread.png'),
  'thumbnail-none': require('./icon-thumbnail-none.png'),
  'unarchive': require('./icon-unarchive.png'),
  'user': require('./icon-user.png'),
};
export default IconAssets;
